import OfferStatusEnum from '@constants/enums/offer/status';
import OfferWorkflowStatusEnum from '@constants/enums/offer/workflowStatus';
import SDRLabelEnum from '@constants/enums/SDRLabel';

import i18n from '@plugins/i18n';

import { OfferCollection } from '@/models';

export class OfferVctCollection extends OfferCollection {
    static type = 'OfferVctCollection';

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                sortable: true
            }),
            this.createHeader('workflow_status', i18n.t('workflow_status'), {
                active: false,
                format: 'enum',
                width: '9rem',
                filterable: this.filter_workflow_status
                    ? {
                          operators: this.getOperators(['eq', 'neq', 'in'])
                      }
                    : false,
                enum: OfferWorkflowStatusEnum,
                enumA11yKey: 'enums.offer_workflow_status',
                enumTypes: {
                    [OfferWorkflowStatusEnum.DRAFT]: 'grey',
                    [OfferWorkflowStatusEnum.LIVE]: 'success'
                }
            }),
            this.createHeader('status', i18n.t('status'), {
                format: 'enum',
                width: '7rem',
                filterable: true,
                sortable: true,
                enum: OfferStatusEnum,
                enumA11yKey: 'enums.offer_status',
                enumTypes: {
                    [OfferStatusEnum.OPEN]: 'info',
                    [OfferStatusEnum.CLOSED]: 'error',
                    [OfferStatusEnum.EVERGREEN]: 'success',
                    [OfferStatusEnum.COMING_SOON]: 'warning'
                }
            }),
            this.createHeader('max_fund_size_details', i18n.t('max_fund_size_details'), {
                format: 'wysiwyg',
                width: '25rem'
            }),
            this.createHeader('launch_at', i18n.t('launch_at'), {
                format: 'datetime',
                width: '9rem'
            }),
            this.createHeader('close_at', i18n.t('close_at'), {
                format: 'datetime',
                width: '9rem'
            }),
            this.createHeader('max_size', i18n.t('offer_size'), {
                format: 'money',
                width: '8rem'
            }),
            this.createHeader('over_allotment_available', i18n.t('over_allotting'), {
                format: 'boolean',
                path: 'over_allotment_available',
                transform: data => {
                    if (!data.item.over_allotment_actual && !data.item.over_allotment_proposed) {
                        return false;
                    }

                    return data.item.over_allotment_available;
                },
                filterable: true,
                width: '12rem'
            }),
            this.createHeader('over_allotment', i18n.t('over_allotment'), {
                format: 'money',
                transform: data => {
                    if (data.item.over_allotment_actual) {
                        return data.item.over_allotment_actual;
                    } else if (data.item.over_allotment_proposed) {
                        return data.item.over_allotment_proposed;
                    } else {
                        return null;
                    }
                },
                width: '10rem'
            }),
            this.createHeader('min_investment', i18n.t('min_investment'), {
                format: 'money',
                width: '10rem'
            }),
            this.createHeader('raised', i18n.t('funds_raised'), {
                filterable: true,
                format: 'money',
                width: '9rem'
            }),
            this.createHeader('loyalty_discount', i18n.t('loyalty_discount'), {
                format: 'percentage',
                width: '7rem'
            }),
            this.createHeader('existing_investor_close_at', i18n.t('existing_investor_close_at'), {
                format: 'datetime',
                width: '10rem'
            }),
            this.createHeader('existing_investor_close_description', i18n.t('existing_investor_close_description'), {
                format: 'wysiwyg',
                width: '15rem'
            }),
            // this.createHeader('max_adviser_facilitated', i18n.t('max_adviser_facilitated'), {
            //     format: 'percentage',
            //     width: '7rem'
            // }),

            this.createHeader('sdr_label', i18n.t('sdr_label'), {
                format: 'enum',
                filterable: true,
                enum: SDRLabelEnum,
                enumA11yKey: 'enums.sdr_label',
                width: '8rem',
                active: false
            })
        ];
    }

    get default_headers() {
        return [
            'name',
            'status',
            'max_fund_size_details',
            'close_at',
            'max_size',
            'min_investment',
            'raised',
            'over_allotment_available',
            'over_allotment'
        ];
    }

    get preset_filters() {
        return {
            ...super.preset_filters,
            tax_status: this.filterOperator('is') + ':VCT'
        };
    }
}

export default OfferVctCollection;
